import { minorJackpot } from "../../cashCashPabunot/core/commendation";
import { gameStates } from "./gameStates";

export const globalData = {
    //--------------------------Game information------------------------------------
    currentGameState: gameStates.IDLE,
    turboTimeOut: true,
    winType: "NONE",
    prizeUp: '',
    roundWinnings: 0,
    multiplier: 0,
    bet: 0,
    totalBet: 0,
    minBet: 1,
    maxBet: 100000,
    betSettings: [],
    balance: 0,
    currentRound: 1,
    totalRounds: 5,
    maxRounds: 12,
    gameSpeed: 0.5,
    meterHeightMax: 0,
    currentMeterHeight: 0,
    jeepneyLane: null,
    obstacleLane: 0,
    currentRoundLose: false,
    autoplay: true,
    isNewUser: false,
    roundSettings: [],
    betMultiplier: 10,
    nearMiss: false,
    winComplete: false,
    showAmount: false,
    flag: false,
    numOfRoundsWon: 0,
    jackpotMinorWin: 0,
    jackpotMajorWin: 0,
    jackpotGrandWin: 0,
    jackpotMinorWinAmount: 0,
    jackpotMajorWinAmount: 0,
    jackpotGrandWinAmount: 0,
    jackpot: false,
    jackpotWinAmount: 120000,
    grandCurrentJackpotValue: 0,
    majorCurrentJackpotValue: 0,
    minorCurrentJackpotValue: 0,
    resetGrandJackpotValue: 0,
    resetMajorJackpotValue: 0,
    resetMinorJackpotValue: 0,
    showWinAmount: false,
    isEnglish: true,
    gameLanguage: null,
    response: null,
    jackpotDetails: null,
    minorFlag: null,
    majorFlag: null,
    grandFlag: null,

    tutorialPageSize: 0,
    prizeUpgrade: false,
    showAutoAndTurbo: false,
    isScroll:false,
    prizeScroll: false,
    ftuePrizeScroll: false,
    ftueIsScroll: false,
    tutorialLast: 0,
    betHist: [],
    horizontalScroll: false,
    verticalScroll: false,
    horizontalScrollLeft: false,
    //--------------------------Game Settings---------------------------------------
    sounds: true,
    music: true,
    autoplay: false,
    turbo: 0,
    vibration: true,
    stats: null,
    gameScreenWidth: 0,
    tokenExpired: false,
    pixiStates: null,
    isJackpotActive: false,
    //--------------------------Build information------------------------------------
    version: "1.3.16",
    gameLoaded: false,
    //------------------------Network information---------------------------------
    gameResult: "pending",
    accessToken: 0,
    operatorId: null,
    jwtToken: null,
    userCode: "USER001",
    currencyCode: null,
    gameCode: null,
    lobbyUrl: "http://3.",
    baseUrl: process.env.REACT_APP_BACKEND_URL_HTTP,
    userId: "00"
}

let _isDemo = false;

const demoState = {
    get isDemo() {
        return _isDemo;
    },
    set isDemo(value) {
        _isDemo = Boolean(value);
    }
};

export default demoState;

